import { render, staticRenderFns } from "./FileFornitori.vue?vue&type=template&id=a535c698&scoped=true&"
import script from "./FileFornitori.vue?vue&type=script&lang=js&"
export * from "./FileFornitori.vue?vue&type=script&lang=js&"
import style0 from "./FileFornitori.vue?vue&type=style&index=0&id=a535c698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a535c698",
  null
  
)

export default component.exports